import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-delete-user-icon',
  templateUrl: './communication-delete-user.component.html'
})
export class CommunicationDeleteUserComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
